import { render } from "./ConfiguracionPregunta.vue?vue&type=template&id=2b6682ea&scoped=true"
import script from "./ConfiguracionPregunta.vue?vue&type=script&lang=js"
export * from "./ConfiguracionPregunta.vue?vue&type=script&lang=js"

import "./ConfiguracionPregunta.vue?vue&type=style&index=0&id=2b6682ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6682ea"]])

export default __exports__